import type { ExpiryStatus } from '@vvf/shared';

// Testo leggibile per ogni stato scadenza (unica fonte per F13/F14).
const STATUS_TEXT: Record<ExpiryStatus, string> = {
  Idoneo:      'Idoneo',
  InScadenza:  'In scadenza',
  NonIdoneo:   'Non idoneo',
  NonInserita: 'Non inserita',
};

// Due varianti grafiche: 'badge' (gradiente, usato nell'Armadietto F13)
// e 'deadlines' (pastel legacy, usato nella pagina Scadenze Utenti F14 — pixel-perfect Firebase).
const BADGE_CLASS: Record<ExpiryStatus, string> = {
  Idoneo:      'badge badge-success',
  InScadenza:  'badge badge-warning',
  NonIdoneo:   'badge badge-danger',
  NonInserita: 'badge',
};
const DEADLINES_CLASS: Record<ExpiryStatus, string> = {
  Idoneo:      'deadlines-status status-ok',
  InScadenza:  'deadlines-status status-expiring',
  NonIdoneo:   'deadlines-status status-expired',
  NonInserita: 'deadlines-status status-none',
};

export type ExpiryBadgeVariant = 'badge' | 'deadlines';

/** Badge di stato scadenza condiviso (F13 Armadietto + F14 Scadenze). */
export function ExpiryStatusBadge({ status, variant = 'badge' }: {
  status: ExpiryStatus;
  variant?: ExpiryBadgeVariant;
}): React.JSX.Element {
  const cls = variant === 'deadlines' ? DEADLINES_CLASS[status] : BADGE_CLASS[status];
  return <span className={cls}>{STATUS_TEXT[status]}</span>;
}
